import { useEffect, useState } from 'react';

export enum Breakpoint {
  XS = 0,
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  XXL = 1536,
}

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(Breakpoint.XS);

  const getBreakpointFromWidth = (width: number) => {
    let newBreakpoint = Breakpoint.XS;
    if (width >= Breakpoint.XXL) {
      newBreakpoint = Breakpoint.XXL;
    } else if (width >= Breakpoint.XL) {
      newBreakpoint = Breakpoint.XL;
    } else if (width >= Breakpoint.LG) {
      newBreakpoint = Breakpoint.LG;
    } else if (width >= Breakpoint.MD) {
      newBreakpoint = Breakpoint.MD;
    } else if (width >= Breakpoint.SM) {
      newBreakpoint = Breakpoint.SM;
    }
    return newBreakpoint;
  };

  const handleResize = () => {
    const newBreakpoint = getBreakpointFromWidth(window.innerWidth);
    if (breakpoint !== newBreakpoint) {
      setBreakpoint(newBreakpoint);
    }
  };

  useEffect(() => {
    setBreakpoint(getBreakpointFromWidth(window.innerWidth));

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return breakpoint;
}
